import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import InputField from "../Components/InputField";
import Dropdown from "../Components/Dropdown";
import { getBRBDDirectors,getBRBDProperties,getBRBDResources } from "../Api/BRBD";
import { useAuth } from "../Context/AuthContext";
import { Base_URL  } from "../url";
import axios from "axios";
import { toast } from "react-toastify";
import ViewBrBDDocuments from "./ViewBRBDDocuments";
import { fetchMerchants } from "../Api/ViewMerchantMaster";
import { fetchCustomerMasterByOrgId } from "../Api/ViewCustomerMaster";
import { fetchHouseBanks } from "../Api/ViewHouseBank";
const BRBD = ({ selectedType, statementId,statement,selectedCurrency }) => {
  const { user } = useAuth();
const [showViewModal, setShowViewModal] = useState(false);
  const [head3, setHead3] = useState("");
  const [head2, setHead2] = useState("");
  const[remarks,setRemarks]=useState("");
  const [directors, setDirectors] = useState([]);
  const [selectedDirector, setSelectedDirector] = useState("");
  const [head3Options, setHead3Options] = useState([]);
useEffect(() => {
  const loadHead3Data = async () => {
    try {
      if (head2 === "FromDirector") {
        const res = await getBRBDDirectors(user?.organisationId?.toString());
        setHead3Options(res || []);
      } 
      else if (head2 === "FromProperties") {
        const res = await getBRBDProperties(user?.organisationId?.toString());
        setHead3Options(res || []);
      } 
      else if(head2==="FromResource")
      {
        const res=await getBRBDResources(user?.organisationId);
        setHead3Options(res || []);
      }
      else if(head2==="FromVendor")
      {

        const res=await fetchMerchants(user?.organisationId);
        setHead3Options(res || []);
      }
      else if(head2==="FromCustomer")
      {

        const res=await fetchCustomerMasterByOrgId(user?.organisationId);
        setHead3Options(res || []);
      }
      else if(head2==="FromLoan")
      {

        const res=await getBRBDDirectors(user?.organisationId);
        setHead3Options(res || []);
      }
      else if(head2==="FromCharges")
{
        const res=await fetchHouseBanks(user?.organisationId);
        setHead3Options(res || []);
}
    } catch (err) {
      console.error("Error fetching Head3 data", err);
      setHead3Options([]);
    }
  };

  if (head2) {
    loadHead3Data();
  } else {
    setHead3Options([]);
  }

  // Reset selected value when Head2 changes
  setHead3("");
}, [head2, user?.organisationId]);

  
  const handleSubmit = async () => {
    const paylod={
      brbdHead1: selectedType,
      brbdHead2: head2,
      brbdHead3: head3,
      directorGuid: selectedDirector,
      docfy: statement.valueDate.split("-")[0], // Extract year from date
      brbdAmount: parseFloat(statement.transactionAmount),
      brbdCurrency: selectedCurrency,
      brbdDocumentType:selectedType,
      organisationId: user?.organisationId?.toString(),
      brbdremarks:remarks,
      statementId: statementId
    };
    const res=await axios.post(`${Base_URL}/BRBD/InsertIntoBrbd/${user?.userId?.toString()}`,paylod);
    if(res.status===204)
    {
        toast.success("BRBD entry created successfully for statement!",`${statementId}`);
    }
    else
    {
        toast.error("Failed to create BRBD entry for statement!",`${statementId}`);
    }
  };
// Add this mapping object above return
const head2Mapping = {
  K1: "FromDirector",
  K2: "FromVendor",
  K3: "FromResource",
  K4: "FromResource",
  K5: "FromResource",
  K6: "FromVendor",
  K7: "FromResource",
  K8: "FromResource",
  K9: "FromCustomer",
  R1: "FromProperties",
  Z2: "FromLoan",
  Z3: "FromCharges",
  Z4: "FromVendor"
};

// Create Head2 options dynamically
const head2Options = head2Mapping[selectedType]
  ? [
      {
        label: head2Mapping[selectedType],
        value: head2Mapping[selectedType]
      }
    ]
  : [];
  useEffect(() => {
  if (head2Mapping[selectedType]) {
    setHead2(head2Mapping[selectedType]);
  } else {
    setHead2("");
  }
}, [selectedType]);
  return (
    <div className="mt-4 p-3 border rounded">
        <Row>
            <Col>
            <Button variant="primary" onClick={() => setShowViewModal(true)}>
      View Documents
    </Button>
            </Col>
        </Row>
      <Row className="mb-3">
        {/* <Col md={3}>
          <strong>Head 1:</strong> {selectedType}
        </Col> */}
        
  <Col md={3}>
<Col md={3}>
  <Dropdown
    label="Head 2"
    options={head2Options}
    value={head2}
    onChange={(e) => setHead2(e.target.value)}
    optionLabel="label"
    optionValue="value"
    style={{ minWidth: "50px" }}
  />
</Col>
  </Col>
    <Col md={3}>
         <Dropdown
  label="Head 3"
  options={head3Options}
  value={head3}
  onChange={(e) => setHead3(e.target.value)}
  optionLabel={
    head2 === "FromDirector"
      ? "directorName"
      : head2 === "FromProperties"
      ? "propertyName" 
      
      : head2 === "FromResource"
      ? "name"
        
      : head2 === "FromVendor"
      ? "name"
      : head2 === "FromCustomer"
      ? "name"
      : head2 === "FromLoan"
      ? "directorName"
      : head2 === "FromCharges"
      ? "bankName"
      : ""


  }
  optionValue={
    head2 === "FromDirector"
      ? "directorMasterGuid"
      : head2 === "FromProperties"
      ? "propertyGuid"   // adjust based on API response
      : head2 === "FromResource"
      ? "resourceGuid"
      : head2 === "FromVendor"
      ? "vendorCode"
      : head2 === "FromCustomer"
      ? "customerCode"
      : head2 === "FromLoan"
      ? "directorMasterGuid"
      : head2 === "FromCharges"
      ? "housebankId"
      : ""

  }
/>
        </Col>
        <Col md={3}>
          <InputField
            label="Remarks"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </Col>
       
    
      
      </Row>
      <Row>
            <Col md={4} >
             <Button variant="success" onClick={handleSubmit}>
        Submit
        </Button></Col>
      </Row>
  <ViewBrBDDocuments
  show={showViewModal}
  handleClose={() => setShowViewModal(false)}
/>
    </div>
  );
};

export default BRBD;